<h1 style="margin-left: 20px;">About</h1>
<div class="para">
<p>
  Mainetec is a Mackay based engineering and fabrication 
  company. At Mainetec we focus on providing our customers with superior quality products,
  supported by our extensive capabilities, industry knowledge and unsurpassed on-site service.
  Our high-quality services have been developed to support the asset cycle from start to finish.

Formerly Innovative Mining & Engineering Solutions (IMES), Mainetec was formed in 2010 by director 
Brett Hampson. The vision for the company was to bring innovation to the resource sector, which remains
our philosophy today. Our key focus is to not only provide high-quality deliverables at the best price but 
to go one step further actively partnering with our customers to reduce their asset operating costs.

At Mainetec, we are constantly reviewing current work practices to assess their validity, whilst looking 
for ways to deliver genuine improvements for our clients.

</p>
<p>View our <a href="#">capability statement</a> and <a href="##">Contact us</a> today, let us show you the Mainetec difference.</p>
</div>
<mat-divider></mat-divider>
<mat-grid-list cols="5" rowHeight="1:1" rowHeight="200px">
  <mat-grid-tile>
  <mat-icon>SAFETY</mat-icon>
</mat-grid-tile>
<mat-grid-tile>
  <mat-icon>QUALITY</mat-icon>
</mat-grid-tile>
<mat-grid-tile>
  <mat-icon>EQUALITY</mat-icon>
</mat-grid-tile>
<mat-grid-tile>
  <mat-icon>HONESTY</mat-icon>
</mat-grid-tile>
<mat-grid-tile>
  <mat-icon>RESPECT</mat-icon>
</mat-grid-tile>

</mat-grid-list>